var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM14.2929 8.15289C14.6834 7.76237 15.3166 7.76237 15.7071 8.15289C16.0676 8.51338 16.0953 9.08061 15.7903 9.4729L15.7071 9.56711L13.4142 11.86L15.7071 14.1529C16.0976 14.5434 16.0976 15.1766 15.7071 15.5671C15.3466 15.9276 14.7794 15.9553 14.3871 15.6503L14.2929 15.5671L12 13.2742L9.70711 15.5671C9.31658 15.9576 8.68342 15.9576 8.29289 15.5671C7.93241 15.2066 7.90468 14.6394 8.2097 14.2471L8.29289 14.1529L10.5858 11.86L8.29289 9.56711C7.90237 9.17658 7.90237 8.54342 8.29289 8.15289C8.65338 7.79241 9.22061 7.76468 9.6129 8.0697L9.70711 8.15289L12 10.4458L14.2929 8.15289Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseCircle);
export default __webpack_public_path__ + "static/media/ic_close-circle.daf9206cecf39f81fd3c82c8aff5c681.svg";
export { ForwardRef as ReactComponent };